export default {
  'AdminUser': {
    collection: 'adminUsers',
    element: 'adminUser',
    label: 'name',
    enum: {
    }
  },
  'AdminUsersRole': {
    collection: 'adminUsersRoles',
    element: 'adminUsersRole',
    label: 'id',
    enum: {
    }
  },
  'Role': {
    collection: 'roles',
    element: 'role',
    label: 'name',
    enum: {
      kinds: [
        'super',
        'application',
        'custom',
      ],
    }
  },
  'Application': {
    collection: 'applications',
    element: 'application',
    label: 'name',
    enum: {
    }
  },
  'ActiveStorage::Attachment': {
    collection: 'activeStorage/attachments',
    element: 'activeStorage/attachment',
    label: 'name',
    enum: {
    }
  },
  'Banner': {
    collection: 'banners',
    element: 'banner',
    label: 'id',
    enum: {
      page_positions: [
        'event',
      ],
      kinds: [
        'web_link',
        'image',
        'mp_link',
      ],
    }
  },
  'User': {
    collection: 'users',
    element: 'user',
    label: 'id',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
      verification_states: [
        'init',
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'Miapay::WalletHolder': {
    collection: 'miapay/walletHolders',
    element: 'miapay/walletHolder',
    label: 'phone',
    enum: {
      id_types: [
        'togolese_passport',
        'id_card',
        'other_passport',
      ],
      verify_types: [
        'by_agent',
        'by_self',
      ],
    }
  },
  'Profile': {
    collection: 'profiles',
    element: 'profile',
    label: 'email',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'Agent': {
    collection: 'agents',
    element: 'agent',
    label: 'id',
    enum: {
      statuses: [
        'pending',
        'approved',
        'rejected',
        'actived',
      ],
    }
  },
  'StoreOwner': {
    collection: 'storeOwners',
    element: 'storeOwner',
    label: 'email',
    enum: {
      kinds: [
        'individual',
        'retail',
        'business',
      ],
      sources: [
        'admin_create',
        'sign_up',
      ],
    }
  },
  'Merchant': {
    collection: 'merchants',
    element: 'merchant',
    label: 'name',
    enum: {
    }
  },
  'Event': {
    collection: 'events',
    element: 'event',
    label: 'id',
    enum: {
      states: [
        'will_start',
        'actived',
        'expired',
      ],
    }
  },
  'Walk::Account': {
    collection: 'walk/accounts',
    element: 'walk/account',
    label: 'id',
    enum: {
    }
  },
  'ActiveStorage::Blob': {
    collection: 'activeStorage/blobs',
    element: 'activeStorage/blob',
    label: 'id',
    enum: {
    }
  },
  'ActsAsTaggableOn::Tag': {
    collection: 'actsAsTaggableOn/tags',
    element: 'actsAsTaggableOn/tag',
    label: 'name',
    enum: {
      kinds: [
        'ticket_event',
        'pavillon',
        'explore',
      ],
    }
  },
  'Page': {
    collection: 'pages',
    element: 'page',
    label: 'title',
    enum: {
      statuses: [
        'draft',
        'published',
      ],
    }
  },
  'PresetPage': {
    collection: 'presetPages',
    element: 'presetPage',
    label: 'title',
    enum: {
      statuses: [
        'draft',
        'published',
      ],
    }
  },
  'StaticPage': {
    collection: 'staticPages',
    element: 'staticPage',
    label: 'title',
    enum: {
      statuses: [
        'draft',
        'published',
      ],
    }
  },
  'CustomPage': {
    collection: 'customPages',
    element: 'customPage',
    label: 'title',
    enum: {
    }
  },
  'HotWord': {
    collection: 'hotWords',
    element: 'hotWord',
    label: 'name',
    enum: {
    }
  },
  'WithdrawalApplication': {
    collection: 'withdrawalApplications',
    element: 'withdrawalApplication',
    label: 'id',
    enum: {
      states: [
        'init',
        'completed',
        'rejected',
      ],
    }
  },
  'Miapay::FundingSource': {
    collection: 'miapay/fundingSources',
    element: 'miapay/fundingSource',
    label: 'id',
    enum: {
    }
  },
  'Feedback': {
    collection: 'feedbacks',
    element: 'feedback',
    label: 'phone',
    enum: {
    }
  },
  'Plutus::Entry': {
    collection: 'plutus/entries',
    element: 'plutus/entry',
    label: 'id',
    enum: {
    }
  },
  'Miapay::TransactionMetaDatum': {
    collection: 'miapay/transactionMetaData',
    element: 'miapay/transactionMetaDatum',
    label: 'id',
    enum: {
      kinds: [
        'topup',
        'withdraw',
        'transfer',
        'pay_with_qr_code',
        'cashback',
        'create_red_packet',
        'receive_red_packet',
        'red_packet_expire',
        'order_ticket',
        'electricity',
        'airtime',
        'join_challenge',
      ],
      cashback_kinds: [
        'signup',
        'daily_login',
        'first_topup',
        'topup',
        'percentage_based_cashback',
        'first_payment',
        'payment_to_merchants',
        'transfer',
        'bind_invitor',
        'invited_per_user',
        'heba_walk',
      ],
      states: [
        'init',
        'completed',
        'failed',
        'canceled',
      ],
    }
  },
  'RedPacket': {
    collection: 'redPackets',
    element: 'redPacket',
    label: 'id',
    enum: {
      states: [
        'init',
        'actived',
        'completed',
        'expired',
      ],
      kinds: [
        'cash',
        'cashback',
      ],
    }
  },
  'Brand': {
    collection: 'brands',
    element: 'brand',
    label: 'name',
    enum: {
    }
  },
  'CustomListItem': {
    collection: 'customListItems',
    element: 'customListItem',
    label: 'id',
    enum: {
    }
  },
  'PushNotificationHistory': {
    collection: 'pushNotificationHistories',
    element: 'pushNotificationHistory',
    label: 'id',
    enum: {
      kinds: [
        'sms',
        'client',
        'agent',
      ],
    }
  },
  'TicketEvent': {
    collection: 'ticketEvents',
    element: 'ticketEvent',
    label: 'title',
    enum: {
    }
  },
  'TicketKind': {
    collection: 'ticketKinds',
    element: 'ticketKind',
    label: 'title',
    enum: {
      expiration_kinds: [
        'base_on_event',
        'custom',
      ],
      activity_time_kinds: [
        'exact_date',
        'day_of_week',
      ],
    }
  },
  'TicketOrder': {
    collection: 'ticketOrders',
    element: 'ticketOrder',
    label: 'id',
    enum: {
      ticket_export_statuses: [
        'init',
        'pending',
        'progressing',
        'completed',
      ],
      states: [
        'pending',
        'paid',
      ],
    }
  },
  'TicketOrderItem': {
    collection: 'ticketOrderItems',
    element: 'ticketOrderItem',
    label: 'id',
    enum: {
    }
  },
  'Ticket': {
    collection: 'tickets',
    element: 'ticket',
    label: 'id',
    enum: {
    }
  },
  'ResetPasswordApplication': {
    collection: 'resetPasswordApplications',
    element: 'resetPasswordApplication',
    label: 'id',
    enum: {
      id_types: [
        'togolese_passport',
        'id_card',
        'other_passport',
      ],
      states: [
        'init',
        'approved',
        'rejected',
      ],
    }
  },
  'TicketRedeemBatch': {
    collection: 'ticketRedeemBatches',
    element: 'ticketRedeemBatch',
    label: 'id',
    enum: {
    }
  },
  'TicketRedeemItem': {
    collection: 'ticketRedeemItems',
    element: 'ticketRedeemItem',
    label: 'id',
    enum: {
      update_statuses: [
        'init',
        'success',
        'failed',
      ],
    }
  },
  'CustomList': {
    collection: 'customLists',
    element: 'customList',
    label: 'name',
    enum: {
      kinds: [
        'merchant_list',
        'list_with_image',
        'video_list',
        'image',
      ],
    }
  },
  'Walk::HebaRewardRuleItem': {
    collection: 'walk/hebaRewardRuleItems',
    element: 'walk/hebaRewardRuleItem',
    label: 'id',
    enum: {
    }
  },
  'Walk::HebaParticipationRecord': {
    collection: 'walk/hebaParticipationRecords',
    element: 'walk/hebaParticipationRecord',
    label: 'id',
    enum: {
      states: [
        'pending',
        'completed',
        'failed',
      ],
      reward_states: [
        'init',
        'pending',
        'received',
      ],
    }
  },
  'Walk::StepRecord': {
    collection: 'walk/stepRecords',
    element: 'walk/stepRecord',
    label: 'id',
    enum: {
      error_message_codes: [
        'only_first_wallet_holder_of_the_same_device_is_active',
        'only_highest_step_on_the_same_date_is_active',
        'walk_account_locked',
      ],
    }
  },
  'UserRequest': {
    collection: 'userRequests',
    element: 'userRequest',
    label: 'id',
    enum: {
      states: [
        'pending',
        'paid',
      ],
    }
  },
  'Walk::Club': {
    collection: 'walk/clubs',
    element: 'walk/club',
    label: 'name',
    enum: {
    }
  },
  'Walk::Prize': {
    collection: 'walk/prizes',
    element: 'walk/prize',
    label: 'title',
    enum: {
    }
  },
  'Walk::Challenge': {
    collection: 'walk/challenges',
    element: 'walk/challenge',
    label: 'title',
    enum: {
    }
  },
  'Walk::ChallengeParticipationRecord': {
    collection: 'walk/challengeParticipationRecords',
    element: 'walk/challengeParticipationRecord',
    label: 'phone',
    enum: {
      states: [
        'pending',
        'paid',
        'completed',
        'failed',
      ],
      reward_states: [
        'init',
        'pending',
        'requested',
        'sent',
        'failed',
      ],
    }
  },
}
